import type { IProjectMember } from "../types";
import type {
  IGetUserDisplayNameProps,
  IGetUserInitialsProps,
} from "../types/assistant-share";

export const getUserInitials = ({
  firstName,
  lastName,
}: IGetUserInitialsProps): string => {
  const first = firstName?.charAt(0)?.toUpperCase() ?? "";
  const last = lastName?.charAt(0)?.toUpperCase() ?? "";
  return first + last || "?";
};

export const getUserDisplayName = ({
  firstName,
  lastName,
}: IGetUserDisplayNameProps): string => {
  const parts = [firstName, lastName].filter(Boolean);
  return parts.join(" ") || "";
};

// NOTE: NSAI-7736 — a member with neither a name nor an email is shown by the
// IdP login name they sign in with.
export const getMemberDisplayName = (member: IProjectMember): string => {
  const parts = [member.firstName, member.lastName].filter(Boolean);
  return parts.join(" ") || member.email || member.username || "";
};

// NOTE: Combines name, email and username for filtering.
export const getMemberSearchValue = (member: IProjectMember): string => {
  const parts = [
    member.firstName,
    member.lastName,
    member.email,
    member.username,
  ].filter(Boolean);
  return parts.join(" ");
};
